import React from "react"
import styled from "styled-components"
import YesNoIcon from "components/YesNoIcon"

const FeedbackIcon = styled.div`
  width: 22px;
  height: 22px;
  color: #4a5b68;
`

const FeedbackIconWrapper = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;
`

const FeedbackHeader = styled.div`
  text-align: left;
  border-bottom: 1px solid #f7f7f7;
  padding-bottom: 8px;
  font-weight: bold;
  padding-top: 5px;
`

const FeedbackSenderPopup = styled.div`
  position: absolute;
  bottom: calc(100% + 22px);
  left: 50%;
  transform: translateX(-50%);
  background: #fff;
  border: 1px solid ${props => props.theme.colors.border};
  padding: 11px 14px 14px 14px;
  min-width: 140px;
  z-index: 999;
  box-shadow: 0px 34px 13px -28px rgba(0, 0, 0, 0.24);
  white-space: nowrap;
  cursor: default !important;
  text-align: left;

  :before {
    content: "";
    display: block;
    position: absolute;
    left: 50%;
    margin-left: -21px;
    top: 100%;
    width: 0;
    height: 0;
    border: 21px solid transparent;
    border-top-color: ${props => props.theme.colors.border};
  }

  :after {
    content: "";
    display: block;
    position: absolute;
    left: 50%;
    margin-left: -20px;
    top: 100%;
    width: 0;
    height: 0;
    border: 20px solid transparent;
    border-top-color: white;
  }

  ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  li {
    font-size: 13px;
    padding: 2px 0;
    color: ${props => props.theme.colors.textPrimary};
  }
`

export default class FeedbackClickable extends React.Component {
  constructor(props) {
    super(props)
    this.state = { open: false }
    this.ref = React.createRef()
  }

  componentDidUpdate(_, prevState) {
    if (this.state.open && !prevState.open) {
      document.addEventListener("click", this.handleOutsideClick)
    } else if (!this.state.open && prevState.open) {
      document.removeEventListener("click", this.handleOutsideClick)
    }
  }

  componentWillUnmount() {
    document.removeEventListener("click", this.handleOutsideClick)
  }

  handleOutsideClick = e => {
    if (this.ref.current && !this.ref.current.contains(e.target)) {
      this.setState({ open: false })
    }
  }

  toggle = e => {
    e.stopPropagation()
    this.setState(s => ({ open: !s.open }))
  }

  render() {
    const { variant, senders, header } = this.props
    const { open } = this.state
    return (
      <FeedbackIconWrapper ref={this.ref}>
        <FeedbackIcon
          onClick={this.toggle}
          style={{
            cursor: "pointer",
            filter: open ? "brightness(0.7)" : "none",
          }}
          onMouseEnter={e => {
            if (!open) e.currentTarget.style.filter = "brightness(0.7)"
          }}
          onMouseLeave={e => {
            if (!open) e.currentTarget.style.filter = "none"
          }}
        >
          <YesNoIcon variant={variant} />
        </FeedbackIcon>
        {open && (
          <FeedbackSenderPopup>
            <FeedbackHeader>{header}</FeedbackHeader>
            <ul>
              {senders.map((sender, i) => (
                <li key={i}>{sender}</li>
              ))}
            </ul>
          </FeedbackSenderPopup>
        )}
      </FeedbackIconWrapper>
    )
  }
}
